import { ReactElement } from 'react'

import { MenuItems } from '../../constants/MenuItems'
import { SidebarDesktopMenuItem } from './SidebarDesktopMenuItem'

export const SidebarDesktopListItems = (): ReactElement => {
  return (
    <ol className="flex flex-col">
      {MenuItems.filter((item) => item.visibleDesktop).map((item) => (
        <SidebarDesktopMenuItem key={item.id} item={item} />
      ))}
    </ol>
  )
}
